import { render } from "./DebugMode.vue?vue&type=template&id=b043f534"
import script from "./DebugMode.vue?vue&type=script&lang=js"
export * from "./DebugMode.vue?vue&type=script&lang=js"
script.render = render

export default script